import React, { useState } from 'react';
import Modal from 'react-modal';
import config from 'config/common';
import lib from 'lib/commons';
import { Formik } from 'formik';
import * as yup from 'yup';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

Modal.setAppElement('#root');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Ho_Chi_Minh');

const ModalRegisterLeagueCollaborator = ({ 
	modalStatus, 
	closeModal, 
	data: { isCreatingLeagueCollaborator = false, allAddress = {} }, 
	createLeagueCollaborator
}) => {
	const [startRegisterDate, setStartRegisterDate] = useState();
	const [endRegisterDate, setEndRegisterDate] = useState();
	const [startPlayDate, setStartPlayDate] = useState();
	const [endPlayDate, setEndPlayDate] = useState();

	const afterOpenModal = () => { };

	const selfClose = (event) => {
		event.preventDefault();
		closeModal();
	};

	const validate = () => {
		let optionsValidate = {
			name: yup.string().required('Hãy nhập thông tin'),
			league_type: yup.string().required('Hãy nhập thông tin'),
			estimated_number_of_player: yup.string().required('Hãy nhập thông tin'),
			province_id: yup.string().required('Hãy nhập thông tin'),
			district_id: yup.string().required('Hãy nhập thông tin'),
			address: yup.string().required('Hãy nhập thông tin'),
			register_start_time: yup.string().required('Hãy nhập thông tin'),
			register_end_time: yup.string().required('Hãy nhập thông tin'),
			league_start_time: yup.string().required('Hãy nhập thông tin'),
			league_end_time: yup.string().required('Hãy nhập thông tin'),
			info: yup.string().required('Hãy nhập thông tin'),
			additional_info: yup.string().required('Hãy nhập thông tin'),
		};

		const schema = yup.object().shape(optionsValidate);

		return schema;
	};

	const handleRegister = (values) => {
		if (isCreatingLeagueCollaborator) {
			return false;
		}

		values = {
			...values,
			district_id: parseInt(values?.district_id),
			province_id: parseInt(values?.province_id),
			estimated_number_of_player: parseInt(values?.estimated_number_of_player),
		};


		createLeagueCollaborator(values, closeModal);
	};

	const allProvinceObj =
		allAddress && allAddress?.all_province
			? lib.toObj(allAddress?.all_province, 'province_id')
			: {};
	const allDistrictObj =
		allAddress && allAddress?.all_district
			? lib.toObj(allAddress?.all_district, 'district_id')
			: {};

	let now = dayjs().tz();

	const minDate = new Date();
	const leagueTypes = config.typeLeagueOffline;
	const leagueTypesName = {
		'OFFLINE_1': '1vs1',
		'OFFLINE_2': '2vs2',
		'OFFLINE_4': 'Volta',
	};

	return (
		<Modal
			isOpen={modalStatus}
			onAfterOpen={afterOpenModal}
			onRequestClose={selfClose}
			contentLabel="Example Modal"
			portalClassName="ReactModalPortal"
			overlayClassName=""
			className="animated fadeInDown faster modal-register-league-collaborator"
		>
			<h2>Đăng ký tổ chức giải đấu</h2>
			<div className="modal-description">
				<div className="register-league">
					<Formik
						enableReinitialize={true}
						validationSchema={validate()}
						initialValues={{
							name: '',
							league_type: '',
							estimated_number_of_player: '',
							province_id: '',
							district_id: '',
							address: '',
							register_start_time: '',
							register_end_time: '',
							league_start_time: '',
							league_end_time: '',
							info: '',
							additional_info: '',
						}}
						onSubmit={(values, actions) => {
							handleRegister(values);
						}}
					>{({
						values,
						errors,
						touched,
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						handleReset,
						isSubmitting,
						/* and other goodies */
					}) => {
						const districts =
							allAddress && allAddress?.all_district
								? allAddress?.all_district.filter(
									(item) => item?.province_id == values?.province_id
								)
								: [];
						return (
							<form className="my-form" onSubmit={handleSubmit}>
								<div className="row align-items-center">
									<div className="col-2">
										<label>Tên giải đấu:</label>
									</div>
									<div className="col-10">
										<div className="register-league__type">
											<div className='register-league__type-input'>
												<input
													type="text"
													name="name"
													onChange={handleChange}
													value={values.name || ''}
													onBlur={handleBlur}
												/>
												{errors.name && touched.name && (
													<p className="text-error text-left text-danger">
														{errors.name}
													</p>
												)}
											</div>
											<div className='register-league__type-select'>
												<div className="selection">
													<span>{values?.league_type
														? leagueTypesName[values?.league_type]
														: 'Chọn thể thức'}</span>
													<select
														name="league_type"
														id=""
														onChange={(event) => {
															setFieldValue('league_type', event.target.value);
														}}
														value={values.league_type || ''}
														onBlur={handleBlur}
													>
														<option value="">Chọn thể thức</option>
														<option value={leagueTypes[0]}>1vs1</option>
														<option value={leagueTypes[1]}>2vs2</option>
														<option value={leagueTypes[2]}>Volta</option>
													</select>
												</div>
												{errors.league_type && touched.league_type && (
													<p className="text-error text-left text-danger">
														{errors.league_type}
													</p>
												)}
											</div>
											<div className='register-league__type-select'>
												<div className="selection">
													<span>{values?.estimated_number_of_player
														? `Số lượng: ${values?.estimated_number_of_player}`
														: 'Chọn số lượng'}</span>
													<select
														name="estimated_number_of_player"
														id=""
														onChange={(event) => {
															setFieldValue('estimated_number_of_player', event.target.value);
														}}
														value={values.estimated_number_of_player || ''}
														onBlur={handleBlur}
													>
														<option value="">Chọn số lượng</option>
														<option value="16">16</option>
														<option value="32">32</option>
														<option value="64">64</option>
														<option value="128">128</option>
														<option value="256">256</option>
													</select>

												</div>
												{errors.estimated_number_of_player && touched.estimated_number_of_player && (
													<p className="text-error text-left text-danger">
														{errors.estimated_number_of_player}
													</p>
												)}
											</div>
										</div>
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-2">
										<label>Địa chỉ:</label>
									</div>
									<div className="col-10">
										<div className="register-league__type">
											<div className='register-league__type-input'>
												<input
													type="text"
													name="address"
													onChange={handleChange}
													value={values.address || ''}
													onBlur={handleBlur}
												/>
												{errors.address && touched.address && (
													<p className="text-error text-left text-danger">
														{errors.address}
													</p>
												)}
											</div>
											<div className='register-league__type-select'>
												<div className="selection">
													<span>
														{values?.province_id
															? allProvinceObj[values?.province_id]
																?.province_name
															: 'Tỉnh/Thành phố'}
													</span>
													<select
														name="province_id"
														id=""
														onChange={(event) => {
															setFieldValue('province_id', event.target.value);
															setFieldValue('district_id', '');
														}}
														value={values.province_id || ''}
														onBlur={handleBlur}
													>
														<option value="">Tỉnh/Thành phố</option>
														{allAddress &&
															allAddress?.all_province &&
															allAddress?.all_province.length > 0 &&
															allAddress?.all_province.map((province, key) => {
																return (
																	<option
																		value={province?.province_id}
																		key={key}
																	>
																		{province?.province_name}
																	</option>
																);
															})}
													</select>
												</div>
												{errors.province_id && touched.province_id && (
													<p className="text-error text-left text-danger">
														{errors.province_id}
													</p>
												)}
											</div>
											<div className='register-league__type-select'>
												<div className="selection">
													<span>
														{/* {typeSearch == 1 ? 'Tên CLB' : 'UID Đội Trưởng'} */}
														{values?.district_id
															? allDistrictObj[values?.district_id]
																?.district_name
															: 'Quận/huyện'}
													</span>
													<select
														name="district_id"
														id=""
														onChange={handleChange}
														value={values.district_id || ''}
														onBlur={handleBlur}
													// value={typeSearch}
													// onChange={(e) => setTypeSearch(e.target.value)}
													>
														<option value="">Quận/huyện</option>
														{districts.length > 0 &&
															districts.map((district, key) => {
																return (
																	<option
																		value={district?.district_id}
																		key={key}
																	>
																		{district?.district_name}
																	</option>
																);
															})}
													</select>
												</div>
												{errors.district_id && touched.district_id && (
													<p className="text-error text-left text-danger">
														{errors.district_id}
													</p>
												)}
											</div>
										</div>
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-3">
										<label>Thời gian mở đăng ký:</label>
									</div>
									<div className="col-9">
										<DatePicker
											showTimeSelect
											dateFormat="HH:mm - dd/MM/yyyy"
											selected={startRegisterDate}
											onChange={(date) => {
												setFieldValue('register_start_time', dayjs(date).format('YYYY-MM-DD HH:mm:ss'));
												setStartRegisterDate(date);
											}}
											minDate={minDate}
											placeholderText="Chọn thời gian mở đăng ký"
											className="my-date-league"
										/>
										{errors.register_start_time && touched.register_start_time && (
											<p className="text-error text-left text-danger">
												{errors.register_start_time}
											</p>
										)}
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-3">
										<label>Thời gian đóng đăng ký:</label>
									</div>
									<div className="col-9">
										<DatePicker
											showTimeSelect
											dateFormat="HH:mm - dd/MM/yyyy"
											selected={endRegisterDate}
											onChange={(date) => {
												setFieldValue('register_end_time', dayjs(date).format('YYYY-MM-DD HH:mm:ss'));
												setEndRegisterDate(date);
											}}
											minDate={minDate}
											placeholderText="Chọn thời gian đóng đăng ký"
											className="my-date-league"
										/>
										{errors.register_end_time && touched.register_end_time && (
											<p className="text-error text-left text-danger">
												{errors.register_end_time}
											</p>
										)}
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-3">
										<label>Thời gian thi đấu:</label>
									</div>
									<div className="col-9">
										<DatePicker
											showTimeSelect
											dateFormat="HH:mm - dd/MM/yyyy"
											selected={startPlayDate}
											onChange={(date) => {
												setFieldValue('league_start_time', dayjs(date).format('YYYY-MM-DD HH:mm:ss'));
												setStartPlayDate(date);
											}}
											minDate={minDate}
											placeholderText="Chọn thời gian thi đấu"
											className="my-date-league"
										/>
										{errors.league_start_time && touched.league_start_time && (
											<p className="text-error text-left text-danger">
												{errors.league_start_time}
											</p>
										)}
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-3">
										<label>Thời gian kết thúc giải:</label>
									</div>
									<div className="col-9">
										<DatePicker
											showTimeSelect
											dateFormat="HH:mm - dd/MM/yyyy"
											selected={endPlayDate}
											onChange={(date) => {
												setFieldValue('league_end_time', dayjs(date).format('YYYY-MM-DD HH:mm:ss'));
												setEndPlayDate(date);
											}}
											minDate={minDate}
											placeholderText="Chọn thời gian kết thúc thi đấu"
											className="my-date-league"
										/>
										{errors.league_end_time && touched.league_end_time && (
											<p className="text-error text-left text-danger">
												{errors.league_end_time}
											</p>
										)}
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-3">
										<label>Giải thưởng tiền mặt:</label>
									</div>
									<div className="col-9">
										<input 
											type="text"
											name="info"
											onChange={handleChange}
											value={values.info || ''}
											onBlur={handleBlur}
										/>
										{errors.info && touched.info && (
											<p className="text-error text-left text-danger">
												{errors.info}
											</p>
										)}
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-3">
										<label>Link nhóm chat:</label>
									</div>
									<div className="col-9">
										<input 
											type="text"
											name="additional_info"
											onChange={handleChange}
											value={values.additional_info || ''}
											onBlur={handleBlur}
										/>
										{errors.additional_info && touched.additional_info && (
											<p className="text-error text-left text-danger">
												{errors.additional_info}
											</p>
										)}
									</div>
								</div>

								<div className="row align-items-center">
									<div className="col-12">
										<div className="note">
											<a href="#">
												<img src="/images/checked.png" alt="" />
												Lưu ý: Vui lòng xác nhận thông tin bạn nhập là chính xác
											</a>
										</div>
									</div>
								</div>

								<div className="row justify-content-center">
									<div className="col-4">
										<button type="submit" className="btn btn--submit btn--fw">
											Đăng ký
										</button>
									</div>
									{/* <div className="col-4">
										<button type="button" className="btn btn--cancel  btn--fw">
											làm lại
										</button>
									</div> */}
								</div>
							</form>
						);
					}}
					</Formik>
				</div>
			</div>
		</Modal>
	);
};

export default ModalRegisterLeagueCollaborator;
